<template>
  <Modal
    :activeModal="isOpenModal"
    :widthModal="450"
    @closeModal="closeModal">
    <v-card class="py-0">
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
          {{ data.affiliate.entity.jsonData.fullName  }}
          <v-spacer></v-spacer>
          <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>

      <v-form>
        <v-card-title class="modal-cadastro-titulo">
         valor da comissão: {{ data.comissionValue | currency  }}
        </v-card-title>

        <v-card-text class="modal-cadastro-form py-0">
          <v-row>
            <v-col cols="12" md="12" class="py-0">
              <v-textarea
                v-model="memo"
                label="Descrição"
                outlined
                dense
                rows="2"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="modal-cadastro-footer">
          <v-btn :color="variables.colorPrimary" @click="closeModal" class="br-btn br-btn-cancelar"> Cancelar </v-btn>
          <v-btn
            type="submit"
            :color="variables.colorPrimary"
            @click.prevent="submit"
            class="br-btn"
            :loading="loading">Rejeitar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// eslint-disable-next-line no-unused-vars
import { errorSnackbar, successSnackbar } from '@/core/service/utils'

import variables from '@/assets/styles/helpers/_variables.scss'

export default {
  name: 'ModalRejetarLiquidacao',
  components: {
    Modal: () => import('@/views/components/modal')
  },
  data: () => ({
    activeModal: false,
    loading: false,
    memo: ''
  }),
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          affiliate: {
            entity: {
              jsonData: {
                fullName: ''
              }
            }
          }
        }
      }
    },
    isOpenModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('auth', ['user']),
    ...mapGetters('liquidacaoContratos', ['user']),
    variables: () => variables,
  },
  mounted () {    
  },
  methods: {
    ...mapActions('liquidacaoContratos', ['rejetarLiquidacoes']),
    closeModal () {
      this.memo = ''
      this.$emit('closeModal', false)
    },
    submit () {
      this.loading = true
      this.rejetarLiquidacoes({ contractSettlementId: this.data.id, memo: this.memo })
        .then(() => {
          successSnackbar('Liquidação rejetado com sucesso') 
          this.memo = ''
          this.$emit('closeModal', true)
        })
        .catch(err => { errorSnackbar(err.error)})
        .finally(() => { this.loading = false })
      return
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
